import { QueryState } from '@/common/enum';
import { Nullable } from 'interfaces/Nullable.ts';

export type StationStateTypes = {
  queryState: QueryState;
  activeGroupId: Nullable<number>;
  error: Nullable<string>;
};

export const StationInitialState: StationStateTypes = {
  queryState: QueryState.UNDEFINED,
  activeGroupId: null,
  error: null,
};
